import { GridColDef } from "@mui/x-data-grid"

export const SHIPPING_COLUMNS: GridColDef[] = [
  { field: "sno", headerName: "S.NO", width: 100 },
  { field: "date", headerName: "DATE", width: 120 },
  { field: "vessel", headerName: "VESSEL", width: 200 },
  { field: "line", headerName: "LINE", width: 120 },
  { field: "bookedBy", headerName: "BOOKED BY", width: 130 },
  { field: "shipper", headerName: "SHIPPER", width: 130 },
  { field: "port", headerName: "PORT", width: 130 },
  { field: "term", headerName: "TERM", width: 100 },
  { field: "desp", headerName: "DESP", width: 130 },
  { field: "tmp", headerName: "TMP", width: 100 },
  { field: "type", headerName: "TYPE", width: 130 },
  { field: "n", headerName: "N", width: 80 },
  { field: "containerNos", headerName: "CONTAINER NOS", width: 150 },
  { field: "trp", headerName: "TRP", width: 100 },
  { field: "truck", headerName: "TRUCK", width: 100 },
  { field: "pt", headerName: "P/T", width: 100 },
  { field: "status", headerName: "STATUS", width: 120 },
  { field: "status1", headerName: "STATUS1", width: 120 },
  { field: "p", headerName: "P", width: 80 },
  { field: "gd", headerName: "GD", width: 130 },
  { field: "s", headerName: "S", width: 130 },
  { field: "dpp", headerName: "DPP", width: 130 },
  { field: "consignee", headerName: "CONSIGNEE", width: 130 },
  { field: "qty", headerName: "QTY", width: 100 },
  { field: "packages", headerName: "PACKAGES", width: 130 },
  { field: "gwt", headerName: "GWT", width: 100 },
  { field: "c", headerName: "C", width: 80 },
  { field: "ef", headerName: "E/F", width: 100 },
  { field: "formENumber", headerName: "FORM E NUMBER", width: 180 },
  {
    field: "exam",
    headerName: "Exam",
    width: 100,
    type: "boolean"
  },
  {
    field: "pictCharges",
    headerName: "PICT Charges",
    width: 130,
    type: "boolean"
  },
  {
    field: "phyto",
    headerName: "Phyto",
    width: 100,
    type: "boolean"
  },
  {
    field: "chamber",
    headerName: "Chamber",
    width: 100,
    type: "boolean"
  },
  {
    field: "terminalCharges",
    headerName: "Terminal Charges",
    width: 150,
    type: "boolean"
  },
  { field: "transport", headerName: "Transport", width: 130 },
  { field: "agency", headerName: "Agency", width: 130 },
  { field: "phytoExtra", headerName: "Phyto", width: 100 }
]
